/*eslint no-var: [2] */
import PropTypes from 'prop-types';

import React from 'react';

class Tags extends React.Component {
    static propTypes = {
        addTag: PropTypes.func.isRequired,
        removeTag: PropTypes.func.isRequired,
        allTags: PropTypes.array,
        selectedTags: PropTypes.array,
    };

    state = { tag: '' };

    onChange = ({ currentTarget: { value }, nativeEvent: { composed } }) => {
        this.setState({ tag: value }, () => {
            // can't check nativeEvent instanceof InputEvent because of IE.
            composed === false && this.onSubmit();
        });
    };

    /**
     * Yes, this seems totally backward. The `<form>` is a parent of all of the
     * `<fieldset>`s so when the user presses enter that event is handled up
     * in <ControlPanel>`. It will notify `<Tags>` when that happens.
     *
     * Right now I'm not interested in figuring out if I can move that `<form>`
     * into this component. I suspect screen readers wouldn't like us splitting
     * every `<fieldset>` into its own `<form>` or making this one the only
     * one wrapped in a `<form>`.
     */
    onSubmit = () => {
        const tag = this.state.tag.trim();
        if (tag !== '') {
            this.props.addTag(tag);
            this.setState({ tag: '' });
        }
    };

    renderTagOptions = () => {
        return this.props.allTags.map(tag => {
            return <option key={tag} value={tag} />;
        });
    };

    render() {
        const tags = this.props.selectedTags.map(tag => {
            const remove = () => this.props.removeTag(tag);
            return (
                <li key={tag} className="tag">
                    {tag}
                    <button type="button" className="remove" onClick={remove}>
                        <i className="cl-icon cl-icon-times-circle">
                            <span className="aural">Remove tag {tag}</span>
                        </i>
                    </button>
                </li>
            );
        });

        return (
            <fieldset>
                <legend className="aural">Filter by tags</legend>
                <div className="filter-control">
                    <label htmlFor="tag-entry" aria-hidden="true">
                        Specific Tags
                    </label>
                    <input
                        aria-label="Specific Tag"
                        autoComplete="off"
                        className="select-tag"
                        id="tag-entry"
                        list="autocomplete-tag-filters"
                        name="tags"
                        onChange={this.onChange}
                        placeholder="Enter tag"
                        type="text"
                        value={this.state.tag}
                    />
                    <datalist id="autocomplete-tag-filters">
                        {this.renderTagOptions()}
                    </datalist>

                    <ul className="tag-list">{tags}</ul>
                </div>
            </fieldset>
        );
    }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/components/all_notes/control_panel/tags.jsx